import { render } from "./LanguageModal.vue?vue&type=template&id=739cbb2e&scoped=true"
import script from "./LanguageModal.vue?vue&type=script&lang=js"
export * from "./LanguageModal.vue?vue&type=script&lang=js"

import "./LanguageModal.vue?vue&type=style&index=0&id=739cbb2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739cbb2e"]])

export default __exports__